import z from "zod";

import {
	type EnqueueTransactionEvent,
	type InitializeEvent,
	type UnloadEvent,
} from "../api-canvas-metadata";

export const setTransactionProcessingPausedEvent = z.object({
	type: z.literal("setTransactionProcessingPaused"),
	paused: z.boolean(),
});
export type SetTransactionProcessingPausedEvent = z.infer<
	typeof setTransactionProcessingPausedEvent
>;
export const publishEvent = z.object({ type: z.literal("publish") });
export type PublishEvent = z.infer<typeof publishEvent>;

export const flushEvent = z.object({ type: z.literal("flush") });
export type FlushEvent = z.infer<typeof flushEvent>;

export type StateSyncServerEvent =
	| UnloadEvent
	| InitializeEvent
	| SetTransactionProcessingPausedEvent
	| EnqueueTransactionEvent
	| FlushEvent
	| PublishEvent;
